import { useState, useEffect, useContext } from "react";
import CryptoJS from "crypto-js";
import { ClientContext } from "../../../contexts/clientProvider";
import { RelatoriosContext } from "../../../contexts/relatoriosProvider";
import LoadingSpinner from "../../Loader/load";
import DataTable from "../../Table";
import BaseSelect from "../../General/FormsComp/Select/BaseSelect";

const PatrimonioCliente = () => {
  const { clientes } = useContext(ClientContext);
  const { patrimoniosCliente } = useContext(RelatoriosContext);
  const [clients, setClients] = useState(null);
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [titulo, setTitulo] = useState(null);
  const [clientInfo, setClientInfo] = useState(null);
  const [encryptedData, setEncryptedData] = useState(null);
  const [selectedClient, setSelectedClient] = useState("");

  useEffect(() => {
    let newClients = clientes ? clientes : [];
    setClients(newClients);
  }, [clientes]);

  const handleSelectClient = async (e) => {
    setLoading(true);
    const id = e.target.value;
    if (!id) {
      setSelectedClient("");
      setDados(null);
      setTitulo(null);
      setClientInfo(null);
      setLoading(false);
      return;
    }
    
    const nTitulo = clients.find((client) => client.id === parseInt(id))?.nome;
    setClientInfo({
      id: id,
      nome: nTitulo,
    });
    setTitulo(nTitulo);
    let nDados = await patrimoniosCliente(id);
    if (nDados) {
      nDados = nDados.map((pat) => {
        return {
          ...pat,
          netiqueta: pat.nEtiqueta,
          nserie: pat.nSerie,
          nmac: pat.nMac,
        };
      });
      setLoading(false);
    }
    setDados(nDados);
  };

  const encryptData = () => {
    if (!clientInfo) return null;
    const data = JSON.stringify(clientInfo);
    const secretKey = "EXPECTO-PATRONUM";
    const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString();
    return encodeURIComponent(encrypted);
  };

  const headers = [
    { label: "Anexo", key: "nome_anexo", sortable: true },
    { label: "Modelo", key: "nome_modelo", sortable: false },
    { label: "Patrimônio", key: "netiqueta", sortable: false },
    { label: "Nº Série", key: "nserie", sortable: false },
    { label: "Nº Mac", key: "nmac", sortable: false },
    { label: "Nome", key: "nome", sortable: false },
    { label: "Setor", key: "setor", sortable: false },
    { label: "Ramal", key: "ramal", sortable: false },
    { label: "IP", key: "ip_estatico", sortable: false },
  ];

  useEffect(() => {
    if (clientInfo) {
      const encrypted = encryptData();
      if (encrypted) {
        setEncryptedData(encrypted);
      }
    }
  }, [clientInfo]);

  return (
    <>
      <div className="flex flex-col sm:flex-row items-start sm:items-end justify-center gap-6 mb-8 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
        <div className="w-full sm:w-80" data-tour-id="relatorio:cliente">
          <BaseSelect
            label="Cliente"
            name="cliente"
            value={selectedClient}
            onChange={handleSelectClient}
            options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
            placeholder="Selecione o cliente"
            valueKey="id"
            labelKey="nome"
          />
        </div>
        
        {encryptedData && dados?.length > 0 && (
          <div className="w-full sm:w-auto">
            <button
              onClick={() => {
                window.open(
                  `/openTable/${encryptedData}`,
                  "_blank"
                );
              }}
              className="flex items-center gap-2 px-6 py-3 bg-vox-blue-600 hover:bg-vox-blue-700 text-white font-semibold rounded-lg transition-all duration-200 hover:scale-105 shadow-lg focus:outline-none focus:ring-2 focus:ring-vox-blue-500 focus:ring-offset-2"
            >
              <svg 
                className="w-5 h-5" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                />
              </svg>
              Visualizar em Tabela
            </button>
          </div>
        )}
      </div>

      {loading && <LoadingSpinner />}
      {dados && <DataTable headers={headers} data={dados} itemsPerPage={5} exportButton={true} docTitle={`Patrimônios da ${titulo}`} fontHeader={8} fontData={7} />}
    </>
  );
};

export default PatrimonioCliente;
